<template>
  <v-container fluid>
    <v-tabs grow icons-and-text>
      <!-- <v-tab v-for="item in tabsList" :key="item">{{ item }}</v-tab> -->
      <v-tabs-slider color="warning"></v-tabs-slider>
      <v-tab>
        Working Hours & Availability Manager
        <v-icon>mdi-calendar-clock</v-icon>
      </v-tab>
      <v-tab color="white"
        >Time Away Management<v-icon>mdi-calendar-remove</v-icon></v-tab
      >
      <v-tab-item>
        <v-sheet elevation="5" class="pa-5 mt-5" color="grey lighten-5">
          <CalendarHours :adi_id="adi_id" />
        </v-sheet>
      </v-tab-item>
      <v-tab-item
        ><v-sheet elevation="5" class="pa-5 mt-5" color="grey lighten-5"
          ><!-- Section 2: Time Away -->
          <TimeAway :adi_id="adi_id" /> </v-sheet
      ></v-tab-item>
    </v-tabs>

    <!-- Success Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      timeout="3000"
      top
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import TimeAway from "./TimeAway.vue";
import CalendarHours from "./CalendarHours.vue";
export default {
  name: "WorkingHoursManagerComp",
  components: { TimeAway, CalendarHours },
  props: ["adi_id"],

  data() {
    return {
      tab: null, // this is for active tab
      tabsList: ["Availability Management", "Time Away Management"],
      quickAction: null,
      dateMenu: false,
      startDateMenu: false,
      endDateMenu: false,

      // Global Diary Start Time
      globalDiaryStart: "09:30",

      // Time options from 12am to midnight every 30 minutes
      timeOptions: this.generateTimeOptions(),

      // Working Hours Data
      workingHours: [
        {
          name: "Monday",
          enabled: true,
          startTime: "09:00",
          endTime: "17:00",
          hasLunch: true,
          lunchStart: "12:00",
          lunchEnd: "13:00",
        },
        {
          name: "Tuesday",
          enabled: true,
          startTime: "09:00",
          endTime: "17:00",
          hasLunch: true,
          lunchStart: "12:00",
          lunchEnd: "13:00",
        },
        {
          name: "Wednesday",
          enabled: true,
          startTime: "09:00",
          endTime: "17:00",
          hasLunch: true,
          lunchStart: "12:00",
          lunchEnd: "13:00",
        },
        {
          name: "Thursday",
          enabled: true,
          startTime: "09:00",
          endTime: "17:00",
          hasLunch: true,
          lunchStart: "12:00",
          lunchEnd: "13:00",
        },
        {
          name: "Friday",
          enabled: true,
          startTime: "09:00",
          endTime: "17:00",
          hasLunch: true,
          lunchStart: "12:00",
          lunchEnd: "13:00",
        },
        {
          name: "Saturday",
          enabled: false,
          startTime: "10:00",
          endTime: "14:00",
          hasLunch: false,
          lunchStart: "",
          lunchEnd: "",
        },
        {
          name: "Sunday",
          enabled: false,
          startTime: "10:00",
          endTime: "14:00",
          hasLunch: false,
          lunchStart: "",
          lunchEnd: "",
        },
      ],

      // Time Away Data
      timeAwayTypes: [
        { text: "Hours Away", value: "hours" },
        { text: "Day Away", value: "day" },
        { text: "Days Away (Range)", value: "days" },
      ],

      newTimeAway: {
        type: "hours",
        reason: "",
        date: null,
        startTime: "",
        endTime: "",
        startDate: null,
        endDate: null,
        allDay: true,
      },

      timeAwayList: [],

      timeAwayHeaders: [
        { text: "Type", value: "type", sortable: true },
        { text: "Period", value: "period", sortable: false },
        { text: "Reason", value: "reason", sortable: true },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],

      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },

  computed: {
    isTimeAwayValid() {
      const timeAway = this.newTimeAway;

      if (timeAway.type === "hours") {
        return timeAway.date && timeAway.startTime && timeAway.endTime;
      }

      if (timeAway.type === "day") {
        return timeAway.date;
      }

      if (timeAway.type === "days") {
        return timeAway.startDate && timeAway.endDate;
      }

      return false;
    },

    enabledDaysCount() {
      return this.workingHours.filter((day) => day.enabled).length;
    },

    totalWeeklyHours() {
      return this.workingHours
        .filter((day) => day.enabled)
        .reduce((total, day) => {
          const hours = parseFloat(this.getWorkingHours(day) || 0);
          return total + hours;
        }, 0)
        .toFixed(1);
    },
  },

  methods: {
    // Generate time options from 12am to midnight every 30 minutes
    generateTimeOptions() {
      const options = [];

      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 30) {
          const timeValue = `${hour.toString().padStart(2, "0")}:${minute
            .toString()
            .padStart(2, "0")}`;
          const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
          const period = hour < 12 ? "AM" : "PM";
          const minuteStr = minute === 0 ? "00" : minute.toString();

          options.push({
            value: timeValue,
            label: `${displayHour}:${minuteStr} ${period}`,
          });
        }
      }

      return options;
    },

    // Format time for display (convert 24hr to 12hr format)
    formatTimeDisplay(time24) {
      if (!time24) return "";

      const [hour, minute] = time24.split(":").map(Number);
      const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      const period = hour < 12 ? "AM" : "PM";
      const minuteStr = minute.toString().padStart(2, "0");

      return `${displayHour}:${minuteStr} ${period}`;
    },

    // Convert time to minutes for calculations
    timeToMinutes(time) {
      if (!time) return 0;
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    },

    // Working Hours Methods
    getWorkingHours(day) {
      if (!day.enabled || !day.startTime || !day.endTime) return null;

      const start = this.timeToMinutes(day.startTime);
      const end = this.timeToMinutes(day.endTime);
      let totalMinutes = end - start;

      // Handle overnight shifts
      if (end < start) {
        totalMinutes = 24 * 60 - start + end;
      }

      if (day.hasLunch && day.lunchStart && day.lunchEnd) {
        const lunchStart = this.timeToMinutes(day.lunchStart);
        const lunchEnd = this.timeToMinutes(day.lunchEnd);
        let lunchDuration = lunchEnd - lunchStart;

        // Handle overnight lunch breaks
        if (lunchEnd < lunchStart) {
          lunchDuration = 24 * 60 - lunchStart + lunchEnd;
        }

        totalMinutes -= lunchDuration;
      }

      return (totalMinutes / 60).toFixed(1);
    },

    applyToWeekdays() {
      const template = this.workingHours[0]; // Use Monday as template
      for (let i = 0; i < 5; i++) {
        this.workingHours[i] = {
          ...this.workingHours[i],
          startTime: template.startTime,
          endTime: template.endTime,
          hasLunch: template.hasLunch,
          lunchStart: template.lunchStart,
          lunchEnd: template.lunchEnd,
        };
      }
      this.showSnackbar("Applied settings to weekdays", "success");
    },

    applyToWeekend() {
      const template = this.workingHours[5]; // Use Saturday as template
      for (let i = 5; i < 7; i++) {
        this.workingHours[i] = {
          ...this.workingHours[i],
          startTime: template.startTime,
          endTime: template.endTime,
          hasLunch: template.hasLunch,
          lunchStart: template.lunchStart,
          lunchEnd: template.lunchEnd,
        };
      }
      this.showSnackbar("Applied settings to weekend", "success");
    },

    applyToAll() {
      const template = this.workingHours[0]; // Use Monday as template
      for (let i = 1; i < 7; i++) {
        this.workingHours[i] = {
          ...this.workingHours[i],
          startTime: template.startTime,
          endTime: template.endTime,
          hasLunch: template.hasLunch,
          lunchStart: template.lunchStart,
          lunchEnd: template.lunchEnd,
        };
      }
      this.showSnackbar("Applied settings to all days", "success");
    },

    // Time Away Methods
    addTimeAway() {
      if (!this.isTimeAwayValid) return;

      const timeAway = {
        id: Date.now(),
        type: this.newTimeAway.type,
        reason: this.newTimeAway.reason || "No reason specified",
        ...this.newTimeAway,
      };

      this.timeAwayList.push(timeAway);
      this.resetTimeAwayForm();
      this.showSnackbar("Time away added successfully", "success");
    },

    removeTimeAway(item) {
      const index = this.timeAwayList.findIndex((t) => t.id === item.id);
      if (index > -1) {
        this.timeAwayList.splice(index, 1);
        this.showSnackbar("Time away removed", "info");
      }
    },

    resetTimeAwayForm() {
      this.newTimeAway = {
        type: "hours",
        reason: "",
        date: null,
        startTime: "",
        endTime: "",
        startDate: null,
        endDate: null,
        allDay: true,
      };
    },

    formatPeriod(item) {
      if (item.type === "hours") {
        return `${this.formatDate(item.date)} ${this.formatTimeDisplay(
          item.startTime
        )} - ${this.formatTimeDisplay(item.endTime)}`;
      }

      if (item.type === "day") {
        return this.formatDate(item.date);
      }

      if (item.type === "days") {
        return `${this.formatDate(item.startDate)} - ${this.formatDate(
          item.endDate
        )}`;
      }

      return "";
    },

    formatDuration(item) {
      if (item.type === "hours") {
        const start = this.timeToMinutes(item.startTime);
        const end = this.timeToMinutes(item.endTime);
        let totalMinutes = end - start;

        // Handle overnight periods
        if (end < start) {
          totalMinutes = 24 * 60 - start + end;
        }

        const hours = (totalMinutes / 60).toFixed(1);
        return `${hours} hours`;
      }

      if (item.type === "day") {
        return "1 day";
      }

      if (item.type === "days") {
        const startDate = new Date(item.startDate);
        const endDate = new Date(item.endDate);
        const days =
          Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
        return `${days} days`;
      }

      return "";
    },

    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },

    getTypeColor(type) {
      const colors = {
        hours: "orange",
        day: "red",
        days: "purple",
      };
      return colors[type] || "grey";
    },

    getTypeIcon(type) {
      const icons = {
        hours: "mdi-clock-outline",
        day: "mdi-calendar-today",
        days: "mdi-calendar-range",
      };
      return icons[type] || "mdi-calendar";
    },

    // General Methods
    saveSettings() {
      const settings = {
        workingHours: this.workingHours,
        timeAway: this.timeAwayList,
        globalDiaryStart: this.globalDiaryStart,
      };

      this.$emit("settings-saved", settings);
      this.showSnackbar("Settings saved successfully!", "success");

      localStorage.setItem("workingHoursSettings", JSON.stringify(settings));
    },

    resetSettings() {
      this.workingHours.forEach((day) => {
        day.enabled = [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
        ].includes(day.name);
        day.startTime = "09:00";
        day.endTime = "17:00";
        day.hasLunch = day.enabled;
        day.lunchStart = "12:00";
        day.lunchEnd = "13:00";
      });

      this.globalDiaryStart = "09:30";
      this.timeAwayList = [];
      this.showSnackbar("Settings reset to default", "info");
    },

    showSnackbar(message, color = "success") {
      this.snackbar = {
        show: true,
        message,
        color,
      };
    },

    loadSettings() {
      // Load from localStorage or API
      const saved = localStorage.getItem("workingHoursSettings");
      if (saved) {
        try {
          const settings = JSON.parse(saved);
          if (settings.workingHours) {
            this.workingHours = settings.workingHours;
          }
          if (settings.timeAway) {
            this.timeAwayList = settings.timeAway;
          }
          if (settings.globalDiaryStart) {
            this.globalDiaryStart = settings.globalDiaryStart;
          }
        } catch (error) {
          console.error("Error loading settings:", error);
        }
      }
    },
  },

  mounted() {
    this.loadSettings();
  },
};
</script>

<style scoped>
.day-card {
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.day-card:hover {
  border-color: #1976d2;
}

.day-disabled {
  opacity: 0.6;
  background-color: #f5f5f5;
}

.v-card-subtitle {
  font-weight: 600;
}

.v-chip {
  margin: 2px;
}

.v-data-table {
  border-radius: 8px;
}

.text-caption {
  font-size: 0.75rem !important;
}

.font-weight-medium {
  font-weight: 500 !important;
}

/* Custom scrollbar for better UX */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Global Diary Settings Card */
.v-card-subtitle {
  color: #1976d2 !important;
  font-weight: 600 !important;
}

/* Summary card styling */
.text-body-2 div {
  margin-bottom: 4px;
}

.text-body-2 div:last-child {
  margin-bottom: 0;
}

/* Enhanced day card styling */
.day-card .v-card-text {
  min-height: 200px;
}

/* Time dropdown styling */
.v-select .v-select__selections {
  font-weight: 500;
}

/* Custom styling for time options */
.v-list-item__title {
  font-family: "Roboto Mono", monospace;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .day-card .v-card-text {
    min-height: auto;
  }
}

/* Animation for cards */
.day-card {
  animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Highlight active time selection */
.v-select--focused .v-input__control {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

/* Better spacing for mobile */
@media (max-width: 600px) {
  .v-container {
    padding: 8px;
  }

  .v-card-text {
    padding: 16px !important;
  }
}

/* Time option styling in dropdown */
.v-list-item--active {
  background-color: rgba(25, 118, 210, 0.1) !important;
}

/* Enhanced dropdown appearance */
.v-select__slot {
  min-height: 40px;
}

/* Time display formatting */
.time-display {
  font-family: "Roboto Mono", monospace;
  font-weight: 500;
}
</style>
